import {
  Button,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography
} from 'antd';
import React, { useState } from 'react';
import '../../../components/Common/Form.css';
import { debounce } from '../../../components/Common/Debounce';
import { getCommunities } from '../../../services/communityService';
import ImageUploadSection from '../../../components/ImageUploadSection';
import { beforeImageUpload } from '../../../utilities/imageUpload';
const { Panel } = Collapse;

const { Text } = Typography;

const CommunityResourceForm = ({
  initialValues,
  onSubmit,
  status,
  setStatus,
  type
}) => {
  const [form] = Form.useForm();
  const [fetchedCommunities, setFetchedCommunities] = useState([]);
  const [fetching, setFetching] = useState(false);
  const fetchCommunitiesHandler = debounce((commSearch) => {
    setFetching(true);
    getCommunities({ pageSize: 1000, pageNo: 1, ...commSearch })
      .then((response) => {
        const data = response.data.paginatedList.map((c) => ({
          label: `${c.code}: ${c.title}`,
          value: c._id
        }));
        setFetchedCommunities(data);
        setFetching(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
  }, 250);
  return (
    <Form
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 21 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}>
      <section>
        <Form.Item
          label="Topic Index"
          name="topicIndex"
          rules={[
            { required: true, message: 'Please input topic index!' }
          ]}>
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Sub Index"
          name="subIndex"
          rules={[{ required: true, message: 'Please input sub index' }]}>
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item
          label="Community"
          name="communityObjectId"
          rules={[
            {
              required: true,
              message: 'Please select a community to link the resource'
            }
          ]}>
          {type.toLowerCase().includes('add') ? (
            <Select
              mode={''}
              placeholder="Search community"
              options={fetchedCommunities}
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              showSearch={true}
              onSearch={fetchCommunitiesHandler}
              style={{ width: '100%' }}
            />
          ) : (
            <Text>
              {initialValues.code}: {initialValues.title}
            </Text>
          )}
        </Form.Item>
        <Form.Item
          label="Type*"
          name="type"
          rules={[
            {
              required: true,
              message: 'type is required'
            }
          ]}>
          <Select>
            <Select.Option value="external_link">
              External link
            </Select.Option>
            <Select.Option value="pdf">PDF</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Title*"
          name="title"
          rules={[{ required: true, message: 'Please input title!' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: false }]}>
          <Input />
        </Form.Item>
        <section>
          <Form.Item label="Link" name="link">
            <Input />
          </Form.Item>
          <Form.Item label="Thumbnail" name="thumbnail">
            <Input />
          </Form.Item>
          <Form.Item label="Topic" name="topic">
            <Input />
          </Form.Item>
        </section>
      </section>
      <Divider />
      {status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      {status.type === 'SUCCESS' ? (
        <Text type="success">Successfully Updated!</Text>
      ) : null}
      {type !== 'Clone' ? (
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      ) : (
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default CommunityResourceForm;
